import React from "react"

function Envelope({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 10.3H25.5C26.6 10.3 27.5 11.3 27.5 12.4V23.6C27.5 24.7 26.6 25.7 25.5 25.7H10.5C9.4 25.7 8.5 24.7 8.5 23.6V12.4C8.5 11.3 9.4 10.3 10.5 10.3Z"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 12.4L18 19L27.5 12.4"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Envelope
